import {
  BOOLEAN_SELECT_LIST_ITEMS,
  Card,
  CrudMode,
  DataDisplay,
  formatBoolean,
  pn,
  useElementBreakpoints,
  ValidationErrors,
} from "@compass/core";
import {
  RadioGroup as MuiRadioGroup,
  Stack,
  Grid,
  Checkbox,
  Typography
} from "@mui/material";
import { FormControlLabel } from "@mui/material";
import { LkRole, LkRoleId, User, UserDto, UserEditResource, UserViewResource } from "generated/openApi";
import "moment-timezone";
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import produce from "immer";
import { Select } from "components";

export const Permissions = (props: {
  crudMode: CrudMode;
  appUserRoleId: number | undefined;
  userDto: UserDto;
  userMembership: string;
  reroute?: (userMembership: string, crudMode: CrudMode) => void;
  userPermissions: number[];
  setUserDto: (value: UserDto) => void;
  onUserPermissionsChange: (value: number[]) => void;
  viewResource: UserViewResource;
  editResource: UserEditResource;
  validationErrors: ValidationErrors;
  selectedRole: LkRole | undefined;
}) => {
  const { breakpointsRef, smallFieldBreakpoints } = useElementBreakpoints();
  const properties = props.viewResource.properties || [];

  // UserPermissions here is just the list of IDs, if the ID is in the list, that is a permission that the user has
  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>, permissionId: number) => {
    const checked = e.target.checked;

    let updatedPermissions: number[];

    if (checked) {
      // Add the permission
      updatedPermissions = [...props.userPermissions, permissionId];
    } else {
      // Remove the permission
      updatedPermissions = props.userPermissions.filter(
        (p) => p !== permissionId
      );
    }

    props.onUserPermissionsChange(updatedPermissions);
  };

  const permissionsField = () => {
    return (
      <MuiRadioGroup
        sx={{
          padding: 1,
        }}
        row
        aria-labelledby="radio-buttons-group"
        name="controlled-radio-buttons-group"
      // value={getValue(q)}
      >
        <Grid container direction="column" spacing="sm">
          {props.editResource.permissions?.map((o, i) => {
            return (
              <Grid
                key={i}
                item
                xs={4}
                style={{ display: "flex", justifyContent: "flex-start" }}
              >
                <Stack direction="row" alignItems="center">
                  <FormControlLabel
                    value={o.id}
                    disabled={props.crudMode == "view" || (props.appUserRoleId != LkRoleId.Cobro && props.appUserRoleId != LkRoleId.Administrator)}
                    control={
                      <Checkbox
                        checked={props.userPermissions.some(
                          (v) =>
                            v == o.id
                        )}
                        onChange={(e) => handleCheckboxChange(e, o.id)}
                        name={o.name}
                        disabled={props.crudMode == "view"}
                      />
                    }
                    label={o.name.replace(/([a-z])([A-Z])/g, '$1 $2')} // CanSeeUserReviews -> Can See User Reviews
                  />
                </Stack>
              </Grid>
            );
          })}
        </Grid>
      </MuiRadioGroup>

    );
  };

  const notifyForUnresponsiveStudentField = () => {
    var propertyName = pn<User>("notifyForUnresponsiveStudent");
    var property = properties.find((x) => x.propertyName === propertyName);

    return (props.crudMode === "view" || (props.appUserRoleId != LkRoleId.Cobro && props.appUserRoleId != LkRoleId.Administrator)) ? (
      <DataDisplay label={property?.displayName}>{formatBoolean(props.userDto.user!.notifyForUnresponsiveStudent)}</DataDisplay>
    ) : (
      <Select
        modelProperty={property}
        errors={props.validationErrors[propertyName]}
        value={BOOLEAN_SELECT_LIST_ITEMS.find((x) => x.id === props.userDto.user!.notifyForUnresponsiveStudent)}
        options={BOOLEAN_SELECT_LIST_ITEMS}
        getOptionLabel={(option) => option.name}
        onChange={(e, value) =>
          props.setUserDto(
            produce(props.userDto, (draft) => {
              draft.user!.notifyForUnresponsiveStudent = value?.id;
            })
          )
        }
      />
    );
  };

  return (
    <Card transparentHeader={true} header={
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <AutoAwesomeOutlinedIcon></AutoAwesomeOutlinedIcon>
          <Typography variant="inherit" paddingLeft={"5px"}>Permissions</Typography>
        </Stack>
      </Stack>
    } fullHeight>

      <Grid ref={breakpointsRef} container spacing="sm">
        <Grid item xs={smallFieldBreakpoints}>
          {permissionsField()}
        </Grid>

        <Grid item xs={smallFieldBreakpoints}>
          {notifyForUnresponsiveStudentField()}
        </Grid>
      </Grid>

    </Card>
  );
};
